import { render, staticRenderFns } from "./PaymentGuaranteeSection.vue?vue&type=template&id=45a0f4e3&scoped=true"
import script from "./PaymentGuaranteeSection.vue?vue&type=script&lang=js"
export * from "./PaymentGuaranteeSection.vue?vue&type=script&lang=js"
import style0 from "./PaymentGuaranteeSection.vue?vue&type=style&index=0&id=45a0f4e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a0f4e3",
  null
  
)

export default component.exports